import { CancelStep } from './cancelModalSteps';
import { CancelForm } from './hooks/useCancelForm';

// Returns true if the user can advance from the given step. Side-effects (setFieldError /
// validate) are intentional — they surface inline errors on the form before blocking advance.
export function canAdvanceFromStep(step: CancelStep, form: CancelForm): boolean {
  switch (step) {
    case 'Cancellation Settings':
      return !form.validate().hasErrors;
    case 'Reservation Handling':
      if (form.values.reservationChoice === null) {
        form.setFieldError('reservationChoice', 'Please choose how to handle reservations');
        return false;
      }
      return true;
    case 'Review':
      return true;
    default:
      return true;
  }
}
